const React = require("react") // eslint-disable-line
const Layout = require("./src/components/layouts/layout") // eslint-disable-line

/**
 *
 * @desc - a function to jump to the correct scroll position
 * @param {Object} location -
 * @param {Number} [yOffset] - // Offset for header height, default = -80;
 */

let lastPagePath = null;

// retry mechanism and a delay to allow time for page rendering
export const onRouteUpdate = ({ location }) => {
	lastPagePath = location.pathname;
	if (location.hash) {
		const id = location.hash.replace("#", ""); // Remove the '#' to get the element ID

		const scrollToElement = () => {
			const element = document.getElementById(id); // Try to find the element by ID

			if (element) {
				// Scroll to the element with smooth behavior
				element.scrollIntoView({ behavior: "smooth" });
			} else {
				// If element is not found, retry after 100ms
				setTimeout(scrollToElement, 100); // Retry after 100ms
			}
		};

		// Start the scroll process after 300ms (after the route is updated and the page is rendered)
		setTimeout(scrollToElement, 300);
	}
};


export const onInitialClientRender = () => {
	document.body.addEventListener('click', (event) => {
		const target = event.target.closest('a[href]');
		if (target && target.href) {
			const url = new URL(target.href, window.location.origin);

			if (url.origin === window.location.origin) {
				const scrollY = window.scrollY;
				sessionStorage.setItem('scrollPosition' + lastPagePath, scrollY.toString());
			}
		}
	});
};

export const onClientEntry = () => {
  const redirects = {
    '/health-wellbeing-and-sports/morning-live/': '/morning-live',
    '/history-and-the-arts/morning-live/': '/morning-live',
    '/society-psychology-and-criminology/morning-live/': '/morning-live',
  }
 
  const path = window.location.pathname
  if (redirects[path]) {
    window.location.replace(redirects[path])
  }
}